import React, { useEffect, useState } from 'react';
import './SeletColumnFilter.scss';
import { useLocation } from 'react-router-dom';

export const SelectColumnFilter = (props) => {
  const { column, list = [], onChange } = props;
  const location = useLocation();
  const { search } = location;
  const searchParams = new URLSearchParams(search);
  const { id } = column;
  const [value, setValue] = useState(searchParams.get(id) || '');

  const onChangeFilterValue = (e) => {
    onChange({ value: e.target.value, id });
    setValue(e.target.value);
  };

  useEffect(() => {
    setValue(searchParams.get(id) || '');
  }, [search]);

  return (
    <span className="column-select-filter">
      <select id={column.id} value={value || ''} onChange={onChangeFilterValue}>
        <option value="">전체</option>
        {list?.map((option) => {
          return (
            <option key={option.id} value={option.id}>
              {option.name}
            </option>
          );
        })}
      </select>
    </span>
  );
};

export default SelectColumnFilter;
